export default __webpack_public_path__ + "static/media/arrow-go.d2c94164.svg";